module.exports = __webpack_public_path__ + "static/media/ic-map-teams.07253cda.svg";